import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, Routes } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AccountService, NoPropsError } from './core/service/account';
import { createLoadErrorUrlTree } from './core/router/guard-navigation.util';
import { AuthenticatorService } from './core/service/authenticator.service';
import { GlobalErrorHandler } from './core/service/error/error-handler.service';

const authGuard: CanMatchFn = () => {
  const authenticator = inject(AuthenticatorService)
  if (!authenticator.isAuthed) {
    return authenticator.login().pipe(
      map(() => authenticator.isAuthed)
    )
  }
  return authenticator.isAuthed
}

const propGuard: CanActivateFn = () => {
  const authenticator = inject(AuthenticatorService)
  const account = inject(AccountService)
  const router = inject(Router)
  const errorHandler = inject(GlobalErrorHandler)
  if (authenticator.isAuthed) {
    return account.getProfile().pipe(
      map(profile => {
        if (profile.props.length > 0) {
          return true
        }
        throw new NoPropsError()
      }),
      catchError((err: unknown) => {
        if (err instanceof NoPropsError) {
          return of(router.createUrlTree(['/no-access']))
        }
        errorHandler.handleError(err)
        return of(createLoadErrorUrlTree(router))
      })
    )
  }
  return false
}

export const routes: Routes = [
  {path: '', redirectTo: 'main', pathMatch: 'full'},
  {path: 'main', loadChildren: () => import('./main/main.routes'), canMatch: [authGuard], canActivate: [propGuard]},
  {path: 'no-access', loadComponent: () => import('./no-access/no-access.component')},
  {path: 'no-permissions', loadComponent: () => import('./no-permissions/no-permissions.component')},
  {path: 'error', loadComponent: () => import('./error/error-page.component')},

  {path: 'invite/confirm', loadComponent: () => import('./invite/confirm/confirm.component')},
  {path: 'invite/:code', loadComponent: () => import('./invite/invite.component')},

  {path: 'confirm/order/:orderUid', loadComponent: () => import('./confirm/order/order.component')},
  {path: 'confirm/trader', loadComponent: () => import('./confirm/trader/trader.component')},

  {path: '**', redirectTo: 'main/not-found'},
]
